<template>
  <div class="short-answer-container">
    <div class="question-stem">{{question.Question}}</div>
    <div class="helper-text">{{question.HelperText}}</div>
    <div class="answer-choices">
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          :checked="question.Comment === `Yes`"
          @change="dispatchInput"
          class="radio-button"
          value="Yes"
          type="radio"
        />
        <div :name="question.QuestionID" class="answer-choice-label">Yes</div>
      </div>
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          :checked="question.Comment === `No`"
          @change="dispatchInput"
          class="radio-button"
          value="No"
          type="radio"
        />
        <div class="answer-choice-label">No</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  methods: {
    dispatchInput(event) {
      this.$emit("dispatch-input", {
        questionId: this.question.QuestionID,
        Comment: event.target.value
      });
    }
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  max-width: 80%;
  font-size: 1em;
  text-align: justify;
  color: #000000;
  margin-bottom: 0.5em;
  line-height: 1.2;
}
.short-answer-container {
  margin-bottom: 3.5em;
  padding-left: 0.5em;
}
.answer {
  height: 1.25em;
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #979797;
  border-bottom: 1px solid grey;
  width: 90%;
  padding: 0.25em;
}
.answer-choice {
  display: flex;
  padding: 0.25em;
}
.answer-choice-label {
  font-family: Arial, Helvetica, sans-serif;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    max-width: 80%;
    font-size: 1.25em;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.5em;
    line-height: 1.2;
  }
  .answer-choice {
    display: flex;
    padding: 0.25em;
    font-size: 1.1em;
  }
}
</style>